import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Button } from '../components/ui/button';

const SupportThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen py-20 flex items-center justify-center" style={{ backgroundColor: '#f7f5f2' }}>
      <div className="container mx-auto px-4 max-w-2xl text-center">
        <div className="bg-white rounded-2xl shadow-xl p-12">
          {/* Heart Icon */}
          <div 
            className="w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8"
            style={{ backgroundColor: '#FF8C1915' }}
          >
            <Heart className="h-12 w-12" style={{ color: '#FF8C19' }} fill="#FF8C19" />
          </div>

          {/* Title */}
          <h1 
            className="text-4xl md:text-5xl font-bold mb-6" 
            style={{ color: '#4a2c1a', fontFamily: 'Georgia, serif' }}
          >
            Thank You
          </h1>

          {/* Message */}
          <p className="text-xl mb-4" style={{ color: '#736c64' }}>
            Your support means the world to us.
          </p>
          <p className="text-lg mb-8" style={{ color: '#736c64' }}>
            Every contribution helps us continue growing our small-batch operation, 
            invest in better equipment, and share the pure taste of upstate New York 
            maple with more people.
          </p>

          {/* Signature */}
          <p className="text-lg italic mb-8" style={{ color: '#4a2c1a' }}>
            With gratitude,<br />
            <span className="font-semibold">Marco & Adam</span>
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/shop')}
              className="text-white font-semibold px-8 py-6 text-lg"
              style={{ backgroundColor: '#FF8C19' }}
            >
              Browse Our Syrup
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="font-semibold px-8 py-6 text-lg border-2"
              style={{ borderColor: '#FF8C19', color: '#FF8C19' }}
            >
              Return Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportThankYou;
